import { ValueError } from "../error/ValueError.js";
/** Function that always returns null. */
export function getNull() {
    return null;
}
/** Is a value null? */
export function isNull(value) {
    return value === null;
}
/** Assert that a value is not null. */
export function assertNull(value) {
    if (value !== null)
        throw new ValueError("Must be null", value);
}
/** Is a value not null? */
export function notNull(value) {
    return value !== null;
}
/** Assert that a value is not null. */
export function assertNotNull(value) {
    if (value === null)
        throw new ValueError("Must not be null", value);
}
/** Get the not-nullish version of value. */
export function getNotNull(value) {
    assertNotNull(value);
    return value;
}
/** Is a value nullish? */
export function isNullish(value) {
    return value === null || value === undefined;
}
/** Assert that a value is not nullish. */
export function assertNullish(value) {
    if (value !== null && value !== undefined)
        throw new ValueError("Must be null or undefined", value);
}
/** Is a value not nullish? */
export function notNullish(value) {
    return value !== null && value !== undefined;
}
/** Assert that a value is not nullish. */
export function assertNotNullish(value) {
    if (value === null || value === undefined)
        throw new ValueError("Must not be null or undefined", value);
}
/** Get the not-nullish version of value. */
export function getNotNullish(value) {
    assertNotNullish(value);
    return value;
}
